import { Pipe, PipeTransform } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { MonitoringPlanType } from 'mbs-ui-shared@models/MonitoringPlanType';
import { MonitoringPlanTypeUtil } from 'mbs-ui-shared@utils/monitoringPlanTypeUtil';
import { isNil } from 'lodash';

@Pipe({
  name: 'monitoringPlanType'
})
export class MonitoringPlanTypePipe implements PipeTransform {
  transform(value: number, args?: any): any {
    const typeValue = typeof value;
    const newValue = typeValue === 'number' ? value : typeValue === 'string' ? +MonitoringPlanType[value] : null;
    if (!isNil(newValue)) {
      let prop = null;
      Array.isArray(args) ? (prop = args[0]) : (prop = args);

      switch (prop) {
        case 'name':
          return MonitoringPlanTypeUtil.getText(newValue, this.i18N);
        case 'iconClass':
        default:
          return MonitoringPlanTypeUtil.getIcon(newValue);
      }
    }
  }

  constructor(private i18N: I18NextPipe) {}
}
